// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__zL3K2","Label":"Input_Label__btEfo","InputElement":"Input_InputElement__1JrWM","Invalid":"Input_Invalid__PM5rt"};